<template>
  <div class="lender-container">
    <div class="user-info-container">
      <div class="user-status" :class="`${profile.status}-profile`">
        {{ $t(`message.profile.status.${profile.status}`) }}
      </div>
      <div class="user-name">
        {{ profile.name_ru.family_name_ru }}
        {{ profile.name_ru.given_name_ru }}
      </div>
      <!-- <div class="user-location">{{ userLocality }}</div> -->
      <div class="user-role">
        <span>{{ $t('message.profile.role.title') }}</span>
        &ensp;
        <span class="role">
          {{ $t(`message.profile.role.${this.profile.role}`) }}
        </span>
      </div>
    </div>
    <div class="offer-container">
      <div class="offer-block">
        <div class="middle-offer-item">
          <base-text-input
            :label="$t('message.profile.lender.offer.amount.title')"
            :placeholder="amountOfferPlaceholder"
            :name="'offerAmount'"
            :validate-rules="'offerAmount'"
            :mask-pattern="'######'"
            v-model="newOffer.loan_amount"
          />
          <div class="notice">* - без учёта комиссий</div>
        </div>
        <div class="middle-offer-item">
          <base-text-input
            :label="$t('message.profile.lender.offer.term.title')"
            :placeholder="amountTermPlaceholder"
            :name="'offerTerm'"
            :validate-rules="'offerTerm'"
            :mask-pattern="'##'"
            v-model="newOffer.loan_term_days"
          />
        </div>
        <div class="middle-offer-item">
          <base-text-input
            :label="$t('message.profile.lender.offer.percent.title')"
            :placeholder="amountPercentPlaceholder"
            :name="'offerPercent'"
            :validate-rules="'offerPercent'"
            :mask-pattern="'####'"
            v-model="newOffer.annual_percent"
          />
        </div>
        <div class="middle-offer-item">
          <div class="expected-income-block">
            <div class="expected-income-label">
                {{ $t('message.profile.lender.offer.income.title') }}
              </div>
            <div class="expected-income">
              {{ expectedIncome }}
            </div>
          </div>
        </div>
        <div class="middle-offer-item">
          <base-text-input
            :label="$t('message.profile.lender.offer.rating.title')"
            :placeholder="$t('message.profile.lender.offer.rating.placeholder')"
            :name="'offerRating'"
            :validate-rules="'offerRating'"
            :mask-pattern="'###'"
            v-model="newOffer.borrower_min_rating"
            :isHaveLinkNotice="true"
            :linkNoticePath="'/questions'"
          />
        </div>
        <div class="middle-offer-item">
          <base-text-input
            :label="$t('message.profile.lender.offer.count.title')"
            :placeholder="$t('message.profile.lender.offer.count.placeholder')"
            :name="'offerCount'"
            :validate-rules="'offerCount'"
            :mask-pattern="'#####'"
            v-model="newOffer.loan_max_count"
            :is-have-notice="true"
            :notice-message="$t('message.profile.lender.offer.count.notice')"
            class="notice-input"
          />
        </div>
        <div class="button-block">
          <base-button
            :text="$t('message.profile.lender.offer.btn')"
            :disabled="isCreateOfferBtnDisabled"
            @click="createOffer()"
          />
        </div>
      </div>
    </div>

    <div class="bottom-line"></div>

    <div class="no-card-container" v-if="!profile.default_card_id">
      <router-link class="no-card-link" to="cards">{{ $t('message.profile.lender.noCardLink') }}</router-link>
      {{ $t('message.profile.lender.noCardText') }}
    </div>

    <div class="active-offers-container loans-container">
      <div class="active-offers-title">
        {{ $t('message.profile.borrower.activeOffers.title') }}
      </div>
      <div class="offers-item-header" v-if="!isLoansListEmpty">
        <div class="name"></div>
        <div class="issued">{{ $t('message.profile.borrower.activeOffers.items.issued') }}</div>
        <div class="amount">{{ $t('message.profile.borrower.activeOffers.items.amount') }}</div>
        <div class="term">{{ $t('message.profile.borrower.activeOffers.items.term') }}</div>
        <div class="percent">{{ $t('message.profile.borrower.activeOffers.items.percent') }}</div>
        <div class="income">{{ $t('message.profile.borrower.activeOffers.items.income') }}</div>
        <div class="issued-by">{{ $t('message.profile.borrower.activeOffers.items.issuedBy') }}</div>
        <div class="peni">{{ $t('message.profile.borrower.activeOffers.items.peni') }}</div>
        <div class="total-amount">{{ $t('message.profile.borrower.activeOffers.items.totalAmount') }}</div>
        <div class="status">{{ $t('message.profile.borrower.activeOffers.items.status') }}</div>
        <div class="pay"></div>
      </div>
      <lender-loan-item
        v-for="item of loansItems"
        :key="item.id"
        :item="item"
        @openExpiredModal="openExpiredModal"
      />
      <div class="more-block">
        <div class="notice">* - без учёта комиссий</div>
        <div class="more-container" @click="showMoreLoans()" v-if="isHasMoreLoans">
          <span>
            {{ $t('message.profile.lender.activeOffers.moreOffers') }}
          </span>
          <img src="../../../public/custom/images/more-arrow-down.svg" alt="More arrow down">
        </div>
      </div>
    </div>

    <div class="active-offers-container">
      <div class="active-offers-title">
        {{ $t('message.profile.lender.activeOffers.title') }}
      </div>
      <div class="offers-item-header" v-if="!isOffersListEmpty">
        <!-- <div class="id"></div> -->
        <div class="amount">{{ $t('message.profile.lender.activeOffers.items.amount') }}</div>
        <div class="term">{{ $t('message.profile.lender.activeOffers.items.term') }}</div>
        <div class="percent">{{ $t('message.profile.lender.activeOffers.items.percent') }}</div>
        <div class="income">{{ $t('message.profile.lender.activeOffers.items.income') }}</div>
        <div class="rating">{{ $t('message.profile.lender.activeOffers.items.rating') }}</div>
        <div class="count">{{ $t('message.profile.lender.activeOffers.items.count') }}</div>
        <div class="status">{{ $t('message.profile.lender.activeOffers.items.status') }}</div>
        <div class="menu"></div>
      </div>
      <lender-offer-item
        v-for="item of offersItems" :key="item.createdAt"
        :item="item"
        @changeOfferStatus="changeOfferStatus"
      />
      <div class="more-block">
        <div class="notice">* - без учёта комиссий</div>
        <div class="more-container" @click="showMoreOffers()" v-if="isHasMoreLenderOffers">
          <span>
            {{ $t('message.profile.lender.activeOffers.moreOffers') }}
          </span>
          <img src="../../../public/custom/images/more-arrow-down.svg" alt="More arrow down">
        </div>
      </div>
    </div>
    <base-modal
      v-if="isShowExpiredModal"
      @close="closeExpiredModal()"
    >
      <template #header>
        <div class="modal-header">
          <img @click.stop="closeExpiredModal()" class="close-image" src="../../../public/custom/images/cross.svg" alt="Cross image">
        </div>
        <div class="modal-title">{{ $t('message.profile.lender.expiredModal.title') }}</div>
        <div class="btns-block">
          <div class="btn-container">
            <base-button
              :text="$t('message.profile.lender.expiredModal.advicesBtn')"
              @click="openClaimAdvicesModal()"
            />
          </div>
          <div class="btn-container">
            <base-button
              :text="$t('message.profile.lender.expiredModal.claimBtn')"
              @click="closeExpiredModal()"
            />
          </div>
        </div>
      </template>
    </base-modal>
    <base-modal
      @close="closeClaimAdvicesModal()"
      v-if="isShowClaimAdvicesModal"
    >
      <template #header>
        <div class="modal-header">
          <img @click.stop="closeClaimAdvicesModal()" class="close-image" src="../../../public/custom/images/cross.svg" alt="Cross image">
        </div>
        <div class="claim-advices-title">
          Практические советы:
        </div>
        <ol class="claim-advices-list">
          <li>
            При невозврате денежных средств в установленный срок у Займодавца возникает право на обращение в суд. Следует учитывать, что в соответствии с условиями договора займа и третейской оговоркой предусмотрен обязательный претензионный порядок и определён суд для рассмотрения споров — постоянно действующий третейский суд Общества с ограниченной ответственностью «Инновационные Финансовые Стратегии».
          </li>
          <li>
            Воспользовавшись инструментами Сервиса можно сформировать Претензию, которая будет направлена Заёмщику (должнику). <b>Обращаем внимание на то, что максимальный размер начисляемых пеней по займу составляет 50% от суммы основного долга. Рекомендуем дождаться предусмотренного начисления и затем сформировать Претензию.</b> Если не дожидаться начисления максимального размера пеней, предусмотренного договором займа, то и подать иск можно на тот размер требований, которые были определены фактической Претензией на дату её составления. В течении 10 дней с момента направления претензии Заёмщиком (должником) должен быть дан ответ Займодавцу на претензию и/или погашены требования.
          </li>
          <li>
            При отсутствии ответа на Претензию и/или отсутствии погашения требований и истечении 10 дневного срока ответа на Претензию Займодавец имеет право обратиться в суд, воспользовавшись инструментами Сервиса по составлению и отправке Искового заявления в третейский суд Общества с ограниченной ответственностью «Инновационные Финансовые Стратегии».
          </li>
          <li>
            <b>В момент подачи Искового заявления должен быть оплачен по <a href="/" target="_blank">реквизитам третейского суда</a> в соответствии с <a href="/" target="_blank">тарифами третейского суда</a> третейский сбор за рассмотрение искового заявления (как правило — 2 БВ) и прикреплён скрин (фото) чека оплаты третейского сбора.</b>
          </li>
          <div class="claim-advices-btns-block">
            <div class="claim-advices-btns-container">
              <base-button
                :text="$t('message.profile.lender.expiredModal.claimBtn')"
                @click="closeClaimAdvicesModal()"
              />
            </div>
          </div>
        </ol>
      </template>
    </base-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTextInput from '../../components/base/BaseTextInput.vue';
import BaseButton from '../../components/base/BaseButton.vue';
import lenderOfferItem from './lenderOfferItem.vue';
import lenderLoanItem from './lenderLoanItem.vue';
import BaseModal from '../../components/base/BaseModal.vue';

export default {
  name: 'LenderProfile',
  inject: ['$httpService'],
  components: {
    BaseTextInput,
    BaseButton,
    lenderOfferItem,
    lenderLoanItem,
    BaseModal
  },
  created() {
    this.offersItems = [...this.offersList];
    this.loansItems = [...this.loansList];
  },
  data() {
    return {
      newOffer: {
        loan_amount: '',
        annual_percent: '',
        loan_term_days: '',
        borrower_min_rating: '',
        loan_max_count: ''
      },
      isBtnLoading: false,
      isOfferMenuOpen: false,
      isShowExpiredModal: false,
      isShowClaimAdvicesModal: false,
      offersItems: [],
      loansItems: [],
      offersParams: {
        page: 0,
        size: 10
      },
      loansParams: {
        page: 0,
        size: 10
      }
    }
  },
  methods: {
    async showMoreLoans() {
      this.loansParams.page = this.loansParams.page + 1;

      await this.$store.dispatch("getLoansList", {...this.loansParams});
      this.loansItems = [...this.loansItems, ...this.loansList];
    },
    async showMoreOffers() {
      this.offersParams.page = this.offersParams.page + 1;

      await this.$store.dispatch('getLenderOffersList', {...this.offersParams});

      this.offersItems = [...this.offersItems, ...this.offersList];
    },
    closeClaimAdvicesModal() {
      this.isShowClaimAdvicesModal = false;
    },
    openClaimAdvicesModal() {
      this.closeExpiredModal();
      this.isShowClaimAdvicesModal = true;
    },
    openExpiredModal() {
      this.isShowExpiredModal = true;
    },
    closeExpiredModal() {
      this.isShowExpiredModal = false;
    },
    async createOffer() {
      const modifyedData = {};

      for (let key in this.newOffer) {
        modifyedData[key] = Number(this.newOffer[key]);
      }

      modifyedData.loan_amount = modifyedData.loan_amount * 100;

      const payload = {...modifyedData};

      try {
        const list = await this.$httpService.offers.createOffer(payload);
        
        if (list.data) {
          this.$toast({text: this.$t('message.profile.lender.offer.toastMsg')});
        }
        this.$emit('createOffer', list.data);
      } catch (error) {
        console.log(error);
      }
    },
    offerMenuToggle() {
      this.isOfferMenuOpen = !this.isOfferMenuOpen;
    },
    async changeOfferStatus(data) {
      this.offersParams.page = 0;
      await this.$store.dispatch('changeOfferStatus', data);
      await this.$store.dispatch('getLenderOffersList', {...this.offersParams});
      this.offersItems = [...this.offersList];
    }
  },
  computed: {
    ...mapGetters(['profile', 'offersList', 'loansList', 'isHasMoreLenderOffers', 'isHasMoreLoans']),
    userLocality() {
      return `${this.profile.address.locality}, ${this.profile.address.country}`;
    },
    isOffersListEmpty() {
      return this.offersItems.length === 0;
    },
    isLoansListEmpty() {
      return this.loansItems.length === 0;
    },
    isCreateOfferBtnDisabled() {
      return this.isHasValidationErrors || this.isHasEmptyFields || !this.profile.default_card_id;
    },
    isHasValidationErrors() {
      return this.errors.items.length > 0;
    },
    isHasEmptyFields() {
      return !this.newOffer.annual_percent || !this.newOffer.loan_amount ||
        !this.newOffer.loan_term_days || !this.newOffer.borrower_min_rating || !this.newOffer.loan_max_count;
    },
    expectedIncome() {
      const year = this.loan_amount;
      const numberOfDays = (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)) ? 366 : 365;
      let expected_income = parseFloat(((+this.newOffer.loan_amount * 100) * +this.newOffer.annual_percent / 100 / numberOfDays * +this.newOffer.loan_term_days));

      return this.isHasValidationErrors ? 0 : (expected_income / 100.00).toFixed(2);
    },
    amountOfferPlaceholder() {
      const amountFrom = window.entityCabinetSettings.offer.minAmount;
      const amountTo = window.entityCabinetSettings.offer.maxAmount;
      return `${this.$t('message.profile.lender.offer.amount.placeholderStart')} ${amountFrom} ${this.$t('message.profile.lender.offer.amount.placeholderEnd')} ${amountTo}`
    },
    amountTermPlaceholder() {
      const termFrom = window.entityCabinetSettings.offer.minTerm;
      const termTo = window.entityCabinetSettings.offer.maxTerm;
      return `${this.$t('message.profile.lender.offer.term.placeholderStart')} ${termFrom} ${this.$t('message.profile.lender.offer.term.placeholderEnd')} ${termTo} ${this.$t('message.profile.lender.offer.term.days')}`
    },
    amountPercentPlaceholder() {
      const percentFrom = window.entityCabinetSettings.offer.minPercent;
      const percentTo = window.entityCabinetSettings.offer.maxPercent;
      return `${this.$t('message.profile.lender.offer.percent.placeholderStart')} ${percentFrom} ${this.$t('message.profile.lender.offer.percent.placeholderEnd')} ${percentTo}`
    },
  }
}
</script>

<style lang="scss" scoped>
  .lender-container {
    @include base-page-container;

    flex-direction: column;
    color: #121212;
  }

  .user-info-container {
    margin-bottom: 60px;
    display: flex;
    flex-direction: column;
  }

  .user-name {
    margin-bottom: 20px;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 500;
    font-size: 26px;
    line-height: 32px;
    display: flex;
    align-items: center;
    letter-spacing: 0.01em;
    color: #000000;
  }

  .user-location,
  .user-role {
    margin-bottom: 12px;
    font-weight: 400;
    font-size: 18px;
    color: #181A1B;
  }

  .user-role {
    margin-bottom: 0;
    display: flex;
    align-items: flex-end;
  }

  .role {
    font-weight: 700;
    font-size: 20px;
    color: #181A1B;
  }

  .offer-container {
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .offer-block {
    display: flex;
    flex-wrap: wrap;
  }

  .middle-offer-item {
    width: 180px;
    margin-right: 25px;
    margin-bottom: 20px;
  }

  .middle-offer-item ::v-deep .label-text,
  .small-offer-item ::v-deep .label-text {
    font-weight: 600;
    font-size: 16px;
    line-height: 130%;
  }

  .middle-offer-item ::v-deep .input-wrapper {
    margin-bottom: 0;
  }

  .notice {
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    color: #333333;
  }

  .small-offer-item {
    width: 90px;
    margin-right: 25px;
  }

  .expected-income-label {
    @include base-input-label;

    font-weight: 600;
    font-size: 16px;
    line-height: 130%;
  }

  .expected-income {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    outline: none;
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 135%;
    background-color: var(--base-input-disabled-bgc);
    color: var(--base-input-disabled-color);
    height: 52px;
    border-radius: var(--base-input-border-radius);
    border: 1px solid var(--base-input-valid-border-bgc);
  }

  .button-block {
    margin-top: 25px;
    width: 265px;
    height: 60px;
  }

  .active-offers-container {
    @include active-offers-container;

    margin-top: 60px;
  }

  .active-offers-title {
    @include active-offers-title;
  }

  .offers-item-header {
    @include offers-item-header;
  }

  .id {
    width: 11%;
    margin-right: 2%;
    @include overflow-elipsis;
  }

  .amount {
    width: 10%;
    margin-right: 2%;
  }

  .term {
    width: 11%;
    margin-right: 2%;
  }

  .percent {
    width: 10%;
    margin-right: 2%;
  }

  .income {
    width: 9%;
    margin-right: 2%;
  }

  .rating {
    width: 7%;
    margin-right: 2%;
  }

  .count {
    width: 10%;
    margin-right: 2%;
  }

  .status {
    width: 10%;
    margin-right: 2%;
  }

  .menu {
    width: 6%;
    display: flex;
    justify-content: flex-end;
    position: relative;
  }

  .published-status {
    width: 48px;
    padding: 8px 15px;
    box-sizing: border-box;
    background: #D6F9D3;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    color: #21A25C;
  }

  .unpublished-status {
    width: 55px;
    padding: 8px 15px;
    box-sizing: border-box;
    background: #FFDBDB;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    color: #C93434;
  }

  .offer-menu-img {
    margin-right: 21px;
    height: 22px;
    width: 22px;
    cursor: pointer;
  }

  .offer-menu {
    padding: 10px 15px;
    box-sizing: border-box;
    position: absolute;
    top: -43px;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FFFFFF;
    border: 1px solid #CDCDCD;
    border-radius: 10px;
    font-size: 16px;
    line-height: 135%;
    color: #333333;
    white-space: nowrap;
  }

  .loans-container {
    @include loan-item-header;

    .pay {
      width: 23px;
    }
  }

  .modal-header {
    @include modal-close-block;
  }

  .modal-title {
    width: 70%;
    margin-bottom: 50px;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.01em;
    color: #101010;
  }

  .btns-block {
    margin-bottom: 35px;
    display: flex;
  }

  .btn-container {
    width: 225px;
    height: 60px;
  }

  .btn-container:first-of-type {
    margin-right: 30px;
  }

  .claim-advices-title {
    width: 100%;
    margin-bottom: 20px;
    padding-left: 20px;
    box-sizing: border-box;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.01em;
    color: #101010;
  }

  .claim-advices-list {
    width: 580px;
    max-width: 100%;
    padding-right: 30px;
    box-sizing: border-box;
    max-height: 500px;
    overflow-y: auto;
    font-weight: 400;
    font-size: 16px;
    line-height: 135%;
    color: #121212;

    li {
      margin-bottom: 10px;
    }

    li:last-of-type {
      margin-bottom: 50px;
    }

    b {
      font-weight: 600;
    }

    a {
      color: #2F80ED;
      text-decoration: none;
    }
  }

  .claim-advices-list::-webkit-scrollbar {
    width: 3px;
    height: 10px;
    margin-right: 5px;
    scroll-padding-top: 5px;
  }

  .claim-advices-list {
      scroll-padding-top: 5px;
  }

  .claim-advices-list::-webkit-scrollbar-track {
      background-color: #ECEEF0;
      border-radius: 20px;
  }

  .claim-advices-list::-webkit-scrollbar-thumb {
      background-color: #878787;
      border-radius: 20px;
  }

  .claim-advices-btns-block {
    width: 100%;
    margin-bottom: 35px;
    display: flex;
    justify-content: center;
  }

  .claim-advices-btns-container {
    width: 100%;
    height: 60px;
  }

  .no-card-container {
  margin-top: 60px;
  padding: 30px;
  box-sizing: border-box;
  width: fit-content;
  background: #F8F8F8;
  border: 1px solid #F49332;
  border-radius: 20px;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.01em;
  color: #101010;
}

.no-card-link {
  color: #41BF7B;
}

.bottom-line {
  width: 100%;
  height: 1px;
  background-color: #41BF7B;
}

.user-status {
  width: fit-content;
  margin-bottom: 10px;
  padding: 5.5px 15px;
  box-sizing: border-box;
  border-radius: 6px;
}

.active-profile {
  color: #21A15C;
  background: #D6F9D3;
}

.inactive-profile,
.waiting {
  color: #CB7723;
  background: #FFF1D5;
}

.blocked-profile {
  color: #c93434;
  background: #ffdbdb;
}

.more-block {
  margin-top: 15px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.more-container {
  width: fit-content;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  cursor: pointer;

  img {
    margin-left: 5px;
  }
}

.notice-input::v-deep .notice-msg {
  width: 290px;
  top: -150px;
}

@media screen and (max-width: 870px) {
  .notice-input ::v-deep .notice-msg {
    width: 290px;
    top: -150px;
    left: -235px;
  }

  .notice-input ::v-deep .notice-arrow {
    left: 240px;
  }
}

@media screen and (max-width: 850px) {
  .loans-container .offers-item-header,
  .offers-item-header {
    display: none;
  }
}

@media screen and (max-width: 500px) {
  .middle-offer-item {
    width: 90%;
  }
}
</style>